/* External */
import { combineReducers } from "redux";

/* Reducers */
import allStations from "./allStations/reducers";
import audioAndSubtitlesPreferences from "./audioAndSubtitlesPreferences/reducers";
import chromecast from "./chromecast/reducers";
import epg from "./epg/reducers";
import global from "./global/reducers";
import homeTab from "./homeTab/reducers";
import isBannerShown from "./appBanner/reducers";
import isModalSelectorOpen from "./modalSelector/reducers";
import navBar from "./navBar/reducers";
import overScreenModal from "./overScreenModal/reducers";
import pdp from "./pdp/reducers";
import player from "./player/reducers";
import screen from "./screen/reducers";
import search from "./search/reducers";
import streamsHistory from "./streamsHistory/reducers";
import user from "./user/reducers";

export default combineReducers({
  allStations,
  audioAndSubtitlesPreferences,
  chromecast,
  epg,
  global,
  homeTab,
  isBannerShown,
  isModalSelectorOpen,
  navBar,
  overScreenModal,
  pdp,
  player,
  screen,
  search,
  streamsHistory,
  user
});
